import React from "react";

export default function IconPlus({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="plus_google">
        <path
          id="Vector"
          d="M9.66663 10.8337H4.66663V9.16699H9.66663V4.16699H11.3333V9.16699H16.3333V10.8337H11.3333V15.8337H9.66663V10.8337Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
